module.exports = __webpack_public_path__ + "static/media/firefox-icon.800cfd1f.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/firefox-icon.png
// module id = 1402
// module chunks = 0